/**
 * User types from SDK: Organisation instance = organisation admin; User instance has userType.
 * - If item is instance of Organisation → 100% organisation admin (SuperAdmin).
 * - If item is instance of User (ManageUser): userType "User" → individual, userType "Employee" → organisation user.
 *
 * @param {object} item - Signed-in item (Organisation or User/ManageUser from SDK).
 * @param {function} OrganizationClass - The Organisation class from SDK for instanceof check.
 * @return {'individual'|'organization'|'organization_user'}
 */
export const getUserTypeFromUser = (item, OrganizationClass) => {
  if (!item) return "individual";
  if (OrganizationClass && item instanceof OrganizationClass) return "organization";
  const userType =
    typeof item.getUserType === "function"
      ? item.getUserType()
      : item.userType;
  const typeStr = userType != null ? String(userType).trim() : "";
  if (typeStr === "Employee") return "organization_user";
  return "individual";
};

/**
 * Session storage value for user type (User, SuperAdmin, Employee).
 * @param {object} item - Same as getUserTypeFromUser.
 * @param {function} OrganizationClass - Same as getUserTypeFromUser.
 * @return {'User'|'SuperAdmin'|'Employee'}
 */
export const getUserTypeSessionValue = (item, OrganizationClass) => {
  const type = getUserTypeFromUser(item, OrganizationClass);
  if (type === "individual") return "User";
  if (type === "organization") return "SuperAdmin";
  return "Employee";
};

export const userTypeSwitch = (id, setIsTypeSelect, setFormData, setErrors) => {
  // console.log(id);
  setIsTypeSelect(id);
  setFormData({});
  setErrors({});
};

export const bytesToMB = (bytes) => {
  return Math.round(bytes / (1024 * 2));
};
